/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Guidance_Onsite_5Inputs */

const en_svr_guidance_onsite_5 = /** @type {(inputs: Svr_Guidance_Onsite_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was site access denied? Specify the reason.`)
};

const ja_svr_guidance_onsite_5 = /** @type {(inputs: Svr_Guidance_Onsite_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現場へのアクセスが拒否されましたか？理由を記載してください。`)
};

const fr_svr_guidance_onsite_5 = /** @type {(inputs: Svr_Guidance_Onsite_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'accès au site a-t-il été refusé ? Précisez la raison.`)
};

const de_svr_guidance_onsite_5 = /** @type {(inputs: Svr_Guidance_Onsite_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wurde der Zugang zum Standort verweigert? Geben Sie den Grund an.`)
};

/**
* | output |
* | --- |
* | "Was site access denied? Specify the reason." |
*
* @param {Svr_Guidance_Onsite_5Inputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_guidance_onsite_5 = /** @type {((inputs?: Svr_Guidance_Onsite_5Inputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Guidance_Onsite_5Inputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_guidance_onsite_5(inputs)
	if (locale === "ja") return ja_svr_guidance_onsite_5(inputs)
	if (locale === "fr") return fr_svr_guidance_onsite_5(inputs)
	return de_svr_guidance_onsite_5(inputs)
});